import { LitElement, html } from "lit"
const { apiFetch } = window.wp

export class CartIcon extends LitElement {
	static properties = {
		nonce: { type: String },
    cart: { type: Object },
    total: { type: Number },
	}

	createRenderRoot() {
		return this
	}

	constructor() {
		super()
		this.total = 0
		this.addEventListener("cart-updated", e => {
			jQuery(document.body).trigger("wc_fragment_refresh")
		})

    this.getCart()
	}

	async getCart() {
    this.total = 0
		//header value in wp-json/wc/store/v1/cart
		let response = await apiFetch({ path: "/wc/store/v1/cart", parse: false })
		this.nonce = response.headers.get("Nonce")
    this.cart = await response.json()
    let newTotal = 0
     this.cart.items?.map(item => {
       newTotal += item.quantity
     })
      this.total = newTotal
	}


	render() {
		return html` <span class="total">${this.total}</span>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none">
				<path
					d="M7.5 7.66952V6.69952C7.5 4.44952 9.31 2.23952 11.56 2.02952C14.24 1.76952 16.5 3.87952 16.5 6.50952V7.88952"
					stroke="#FAFAFA"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round" />
				<path
					d="M9.0008 22H15.0008C19.0208 22 19.7408 20.39 19.9508 18.43L20.7008 12.43C20.9708 9.99 20.2708 8 16.0008 8H8.0008C3.7308 8 3.0308 9.99 3.3008 12.43L4.0508 18.43C4.2608 20.39 4.9808 22 9.0008 22Z"
					stroke="#FAFAFA"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
					stroke-linejoin="round" />
				<path
					d="M15.4945 12H15.5035"
					stroke="#FAFAFA"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round" />
				<path
					d="M8.49451 12H8.50349"
					stroke="#FAFAFA"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round" />
			</svg>`
	}
}
